<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-secure-payment-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                            <p class="cf-modal-head__sub">Règlement BCD</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>
                <div class="cf-dialog-body">

                    <div class="box-body">
                        <div class="border-b-0 border-gray-200 dark:border-white/10">
                            <nav class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400" aria-label="Tabs">
                                <button type="button" class="hs-tab-active:bg-white hs-tab-active:border-b-transparent
                                                hs-tab-active:text-primary dark:hs-tab-active:bg-transparent dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:text-primary -mb-px py-2 px-3
                                                 inline-flex items-center gap-2 bg-gray-50 text-sm font-medium text-center border text-defaulttextcolor rounded-t-sm hover:text-primary
                                                 dark:bg-black/20 dark:border-white/10 dark:text-[#8c9097] dark:text-white/50 dark:hover:text-gray-300 active"
                                        id="hs-tab-js-behavior-item-1" data-hs-tab="#hs-tab-js-behavior-1" aria-controls="hs-tab-js-behavior-1">
                                    Information de base
                                </button>



                            </nav>
                        </div>

                        <div class="">
                            <div id="hs-tab-js-behavior-1" role="tabpanel" aria-labelledby="hs-tab-js-behavior-item-1" class="">


                                <div v-if="messagesucces!==''" class="mt-4 mb-4 alert alert-success !border-success/10 flex items-center" role="alert">

                                    <div>
                                       {{messagesucces}}
                                    </div>
                                </div>

                                <div v-if="messageerror!==''" class="mt-4 mb-4 alert alert-danger !border-danger/10 flex items-center" role="alert">

                                    <div>
                                       {{messageerror}}
                                    </div>
                                </div>


                                <div class="alert alert-info text-center mt-3">
                                    <p style="color: black;font-size: 15px;">Date : {{Items.datedoc}} </p>
                                </div>





                                <div class="ti-custom-validation mt-5" >
                                    <div class="grid lg:grid-cols-2 gap-6">

                                        <div class="space-y-2">
                                            <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">N°FACTURE</label>
                                            <input :value="Items.numfacture" type="text" class="form-control" disabled>

                                        </div>

                                        <div class="space-y-2">
                                            <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">FOURNISSEUR</label>
                                            <input :value="Items.namecltfrs" type="text" class="form-control" disabled>

                                        </div>

                                        <div class="space-y-2">
                                            <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">MONTANT TOTAL</label>
                                            <input  :value="formatMoney(Items.mtntotal)" type="text" class="form-control" disabled>

                                        </div>

                                        <div class="space-y-2">
                                            <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0" style="text-transform: uppercase;">MONTANT RESTANT à PAYER</label>
                                            <input :value="formatMoney(mtntrestantapayer)" type="text" class="form-control" disabled>

                                        </div>


                                    </div>

                                    <div class="grid  gap-6 mt-5 lg:grid-cols-1 ">


                                    <div class="space-y-2 mt-5">
                                        <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0" style="text-transform: uppercase;">REGLER PAR</label>
                                        <select @change="checkreglement()"  v-model="Items.reglepar" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                            <option value="Caisse">Caisse</option>
                                            <option value="Banque">Banque</option>
                                        </select>
                                    </div>

                                    </div>


                                    <div class="grid lg:grid-cols-2 gap-6 mt-5" v-if="checkvalue">

                                        <div class="space-y-2">
                                            <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0"
                                                    style="text-transform: uppercase;">BANQUE</label>
                                            <select v-model="Items.reglementbanque" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                                <option :value="null">Sélectionner une banque</option>
                                                <option v-for="(banque,index) of alldata.banque" :key="index" :value="banque">{{banque.name}}</option>

                                            </select>
                                        </div>

                                        <div class="space-y-2">
                                            <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0"
                                                    style="text-transform: uppercase;">MODE DE REGLEMENT</label>
                                            <select v-model="Items.modereglement" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                                <option :value="null">Sélectionner un mode réglement</option>
                                                <option v-for="(modedereglement,index) of datamodereglement" :key="index" :value="modedereglement">{{modedereglement.name}}</option>

                                            </select>
                                        </div>





                                        <div class="space-y-2">
                                            <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">{{deposantname}} </label>
                                            <input v-model="Items.deposantname" type="text" class="form-control">

                                        </div>



                                        <div class="space-y-2">
                                            <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">N°CHEQUE </label>
                                            <input v-model="Items.numcheque" type="text" class="form-control">

                                        </div>





                                    </div>



                                    <div v-if="!checkvalue" class="space-y-2 mt-5">
                                        <label  class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0"
                                                style="text-transform: uppercase;">MODE DE REGLEMENT</label>
                                        <select v-model="Items.modereglement" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                            <option :value="null">Sélectionner un mode de réglement</option>

                                            <option v-for="(modedereglement,index) of datamodereglement" :key="index" :value="modedereglement">{{modedereglement.name}}</option>

                                        </select>
                                    </div>



                                    <div class="space-y-2 mt-5">
                                        <div class=" mt-2">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0"
                                                   style="text-transform: uppercase;">Raison / Motif : </label>
                                            <textarea rows="3" id="mvtobservation" maxlength="225"
                                                      v-model="Items.docobservation"  type="text"
                                                      class="form-control"></textarea>
                                        </div>


                                    </div>

                                    <div  class="space-y-2 mt-5">
                                        <div class=" mt-2">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0"
                                                   style="text-transform: uppercase;" >Montant : </label>

                                            <input   v-model="Items.montant"  type="number" class="form-control">
                                        </div>


                                    </div>



                                </div>
                            </div>



                        </div>
                    </div>




                </div>
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    <button v-if="typeaction==='add'" class="ti-btn ti-btn-primary-full" @click="saveItems">
                        <i class="ri-check-line align-middle"></i> Enregistrer
                    </button>
                    <button v-if="typeaction==='update'" class="ti-btn ti-btn-primary-full">
                        <i class="ri-pencil-line align-middle"></i> Modifier
                    </button>
                </div>

                </div>
            </Transition>
        </div>
    </Transition>

    <validationouinon ref="validationouinon" @aftervalidation="aftervalidation"></validationouinon>
    <modalrapportdeprefdpcc ref="modalrapportdeprefdpcc" ></modalrapportdeprefdpcc>


</template>

<script>
    /*import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/definition/menu";*/
   // import allfunction from "@/allfunction";
    import {currencyFormatDE} from "@/allfunction";
   // import * as JwtService from "@/common/jwt.service";
    import validationouinon from "@/components/views/pages/caisse/bcd/reglement/validationouinon";
    import modalrapportdeprefdpcc from "@/components/views/pages/caisse/rapport/modal_rapport_dep_ref_dpcc";


  //  const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "modalform",
        watch: {


        },

        computed:{


            datamodereglement(){

                let mvalue=this.alldata.modedereglement;

                if (mvalue!==null){

                    if (this.Items.reglepar!==''){
                        let t=this;
                        mvalue = mvalue.filter( function (post) {
                            return    post.code.toLowerCase().includes(t.Items.reglepar.toLowerCase())
                        })

                    }



                }

                return mvalue

            },

            mtntrestantapayer(){
                let mvalue=0

                    mvalue=parseInt(this.Items.mtntrestantapayertrt)

                return mvalue;
            }


        },
        components: {

            modalrapportdeprefdpcc,
            validationouinon

        },

        data() {
            return {
                isdisplay:false,
                messageerror:"",
                messagesucces:"",
                classcaisse:"",
                checkvalue:false,
                titlemodal:"",
                alldata:{},
                typedoc:"",
                deposantname:'',
                typereglement:'',
                authoriationplslignedepense:0,
                typeaction:"add",
                Items: {},
            };
        },
        methods: {

            formatMoney(value){
                return currencyFormatDE(value)

            },

            checkreglement(){
                this.Items.reglementbanque=null
                this.Items.modereglement=null
                if (this.Items.reglepar==="Caisse"){

                    this.classcaisse="col-md-12 mt-2";
                    this.checkvalue=false;

                }else{

                    this.classcaisse="col-md-6 mt-2";
                    this.checkvalue=true;
                }


            },



            aftervalidation(elementSelectionne){

               /// console.log("elementSelectionne ************ ",elementSelectionne)

               /*this.Items.docnum=elementSelectionne.cnumdoc

                let t=this;



                if (t.typedoc==='DPCC' || t.typedoc==='REF'){
                    t.Items.alldepense.push({motif:t.Items.docobservation, montant:t.Items.montant});
                }


                let tabvalue={
                    numdoc:t.Items.docnum,
                    date:t.Items.datedoc,
                    montanttotal:t.Items.montant,
                    montanttotaldelafacure:t.Items.montant,
                    items:t.Items.alldepense,
                    docsaisiepar:t.$store.state.appusername,
                    benrficiaire:t.Items.beneficiaire.name,
                    qrr:t.Items.docnum,
                    patient:t.Items.beneficiaire.name,
                    observations:t.Items.docobservation,
                    typdoc:t.typedoc


                }



                this.$refs.modalrapportdeprefdpcc.show(tabvalue);*/

                this.close();



            },

            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },

            show(titlemodal,typeaction,typedoc,Items,alldata){


                this.titlemodal=titlemodal
                this.typeaction=typeaction
                this.typedoc=typedoc
                this.Items=Items
                //this.typereglement=typereglement
                this.alldata=alldata
                this.messagesucces="";
                this.messageerror="";

                if (this.typedoc==="FRS"){

                    this.deposantname="NOM DU DEPOSANT"

                }
                else{
                    this.deposantname="NOM DU BENEFICIAIRE"
                }

                this.checkreglement();




                this.isdisplay=true;

            },

            currencyFormatDE(p1){
                var number=Number(p1)
                return currencyFormatDE(number)
            },

              async  saveItems(){

                   // this.$store.dispatch('lancerchargement',true)


                  if (this.Items.modereglement===null ){

                      toastr['error']( 'Veuillez sélectionner le mode de réglement.',"<b></b>");
                      return ;

                  }


                  if (this.Items.reglepar==="Banque" ){

                      if (this.Items.reglementbanque===null ){

                          toastr['error']( 'Veuillez sélectionner une banque.',"<b></b>");
                             return ;

                      }



                      if (this.Items.deposantname==='' ){

                          toastr['error']( 'Veuillez saisir le '+this.deposantname+' .',"<b></b>");

                          return ;

                      }



                      if (this.Items.numcheque==='' ){

                          toastr['error']( 'Veuillez saisir le numéro de chèque.',"<b></b>");

                          return ;

                      }





                  }



                  if (this.Items.docobservation===""  || parseFloat(this.Items.montant)===0){

                      toastr['error']( "Veuillez saisir toutes les informations (motif / raison et le montant du réglement)","<b></b>");

                      return


                  }


                  // if (this.doccaisse.mtntrestantapayer<this.doccaisse.mtntrecu ){

                  if (this.mtntrestantapayer>0){
                      if (this.Items.montant===0 || this.Items.montant===''){

                          toastr['error']( "Veuillez saisir toutes les informations (motif / raison et le montant du réglement)","<b></b>");

                          return


                      }

                  }
                  else{
                      if (this.mtntrestantapayer<0){
                          toastr['error']( "Le montant restant ne doit pas être négatif. veuillez vérifier.","<b></b>");

                          return

                      }
                  }


                  if (this.mtntrestantapayer<this.Items.montant ){


                      toastr['error']( "Le montant reçu est supérieur au montant restant à payer.","<b></b>");
                      this.$store.dispatch('lancerchargement',false)
                      return
                  }




                  if (this.typedoc==="FRS"){



                      if (this.Items.reglepar!=="Banque" ){

                          if (this.$store.state.montantencaisse<this.Items.montant ){


                              toastr['error']( "Montant en caisse insuffisant pour effectuer le réglement. Montant en caisse :"+this.currencyFormatDE(this.$store.state.montantencaisse),"<b></b>");

                              return
                          }
                      }



                  }




                  this.Items.cf=this.$store.state.caisseinfo
                  this.Items.document="BCDCA"
                  this.Items.mtntrestantapayer=this.mtntrestantapayer





                  let titlemodal="";

                  titlemodal=`

                      <h4>
                               Voulez-vous vraiment éffectuer le règlement fournisseur de <span style="color: red;font-weight: bold;"> ${this.currencyFormatDE(this.Items.montant)} </span>
                                au nom de <span style="color: black;font-weight: bold;">${this.Items.namecltfrs} ?</span>
                      </h4>

                      `;

                  this.$refs.validationouinon.show(titlemodal,this.Items,this.typedoc);


              },

        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } }
</style>